import { Box, Typography, Button } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

interface PageHeaderProps {
  onBack: () => void;
}

export function PageHeader({ onBack }: PageHeaderProps) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
      <Button onClick={onBack} sx={{ minWidth: 0, p: 0, mr: 1, color: '#23272E', fontSize: 22 }}>
        <ArrowBackIosNewIcon />
      </Button>
      <Box sx={{ width: 56, height: 56, borderRadius: '50%', background: '#E0E7FF', display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1 }}>
        <InfoOutlinedIcon sx={{ color: '#6366F1', fontSize: 32 }} />
      </Box>
      <Typography variant="h5" fontWeight={700} color="#23272E" mb={0.5} textAlign="start">
        Visualizar Equipamento
      </Typography>
    </Box>
  );
} 